import { ResolveFn } from "@angular/router";
import { of } from "rxjs";

export interface AdminRouteData {
  isAdminArea: boolean;
}

export const adminResolver: ResolveFn<AdminRouteData> = () => {
  return of({ isAdminArea: true });
};
